import styled, { css } from "styled-components";
import * as Button from "../Button";

export const Wrapper = styled.dl`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 0;
    font-size: 1.5rem;
    line-height: 2.2rem;

    dt,
    dd {
        margin-bottom: 15px;
        font-size: 1.5rem;
        line-height: 2.2rem;
        color: ${({ theme }) => theme.color.dark};
    }

    dt {
        width: 50%;
        font-family: ${({ theme }) => theme.fontFamily.book};
        font-weight: normal;

        &:last-of-type {
            margin-bottom: 0;
        }

        &[data-rtl="true"] {
            width: 100%;
        }
    }

    dd {
        width: 50%;
        font-family: ${({ theme }) => theme.fontFamily.regular};
        text-align: end;

        &:last-of-type {
            margin-bottom: 0;
        }

        &[data-rtl="true"] {
            width: 100%;
            text-align: right;
        }
    }
`;

export const RegularText = styled.span`
    font-family: ${({ theme }) => theme.fontFamily.regular};
`;

export const MonthlyRateDisclaimer = styled.div<{ centered?: boolean }>`
    margin: 12px 0;

    ${({ centered }) =>
        centered &&
        css`
            text-align: center;
        `};

    ${Button.Link}, div {
        font-size: 1.3rem;
        color: ${({ theme }) => theme.color.grey4};
    }
`;

export const DisclaimerWrapper = styled.span<{ centered?: boolean }>`
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.grey5};
    ${({ centered }) =>
        centered &&
        css`
            display: block;
            text-align: center;
        `};
`;
